export { extractFileExtension, truncateString }

const DEFAULT_MAX_LENGTH = 20

const extractFileExtension = (filename: string): string | null => {
  const lastDotIndex = filename.lastIndexOf('.')

  if (lastDotIndex === -1) {
    return null
  }

  return filename.slice(lastDotIndex + 1).toLowerCase()
}

const truncateString = (
  text: string,
  maxLength: number = DEFAULT_MAX_LENGTH,
): string => {
  if (text.length <= maxLength) {
    return text
  }

  return text.slice(0, maxLength - 1) + '…'
}
